import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Dropdown } from 'shared/ui'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import { type GroupInbox } from 'entities/Inbox/model/GroupInbox'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import {
  actionNewFolder,
  menuNewFolder,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/NewFolder'
import {
  actionRemoveFromFolder,
  menuRemoveFromFolder,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/RemoveFromFolder'
import {
  actionTeamsMute,
  menuTeamsMute,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/TeamsMute'

type PropsDropDown = {
  inbox: Inbox
  groupInbox?: GroupInbox
}

export const DropdownGroupSimpleInbox: FC<PropsDropDown> = observer(({ inbox, groupInbox }) => {
  const store = useConversationMenuContext()

  return (
    <Dropdown
      ariaLabel={'DropdownGroupSimpleInbox'}
      icon={'moreHorizontal'}
      placement={'bottom-end'}
      tooltipProps={{
        disableInteractive: true,
        label: 'Show actions',
        placement: 'top-end',
      }}
      items={[menuRemoveFromFolder(), menuNewFolder(), menuTeamsMute(inbox)]}
      onChange={(item) => {
        actionRemoveFromFolder({ inbox, groupInbox, item }, store)
        actionNewFolder({ inbox, groupInbox, item }, store)
        actionTeamsMute({ inbox, item }, store)
      }}
      width={189}
    />
  )
})
